import React from 'react';
import { GraduationCapIcon, TrendingUpIcon, UsersIcon, ArrowRightIcon } from 'lucide-react';
export function HomeWhyHIRE() {
  const differentiators = [{
    icon: GraduationCapIcon,
    title: 'We Train, You Lead',
    description: 'Every Monday and Tuesday, we run a live, full-day Sales School for your rookies. We provide the rocket fuel and the kick-start, saving you 15+ hours of training time per recruit. You get them back ready to work.'
  }, {
    icon: TrendingUpIcon,
    title: 'Continuous Innovation',
    description: 'The system never stays still. We constantly refine our scripts, funnels, and training based on real-time market data. You always get the latest version of what works—without having to build it yourself.'
  }, {
    icon: UsersIcon,
    title: 'Active Partnership',
    description: "We don't just hand over a login. We act as active consultants, tracking your KPIs and coaching your team to ensure the system delivers math-based results. We are in the trenches with you."
  }];
  return <section className="section-padding bg-white" data-id="element-545">
      <div className="container-custom" data-id="element-546">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-12 lg:mb-16" data-id="element-547">
          <h2 className="mb-3 md:mb-4 lg:mb-6" data-id="element-548">Why HIRE?</h2>
          <p className="text-body-large leading-relaxed" data-id="element-549">
            You don't need more effort. You need a partner that does the heavy
            lifting for you.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6 lg:gap-8 max-w-6xl mx-auto mb-8 md:mb-10 lg:mb-12" data-id="element-550">
          {differentiators.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className="bg-gray-50 rounded p-5 md:p-6 lg:p-8 shadow-lg border-2 border-gray-200 hover:border-amber transition-all" data-id="element-551">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-amber/10 rounded flex items-center justify-center mb-3 md:mb-4" data-id="element-552">
                  <Icon className="h-5 w-5 md:h-6 md:w-6 text-amber" data-id="element-553" />
                </div>
                <h3 className="mb-2 md:mb-3" data-id="element-554">{item.title}</h3>
                <p className="leading-relaxed" data-id="element-555">{item.description}</p>
              </div>;
        })}
        </div>

        <div className="text-center" data-id="element-556">
          <a href="/about" className="inline-flex items-center text-amber font-bold hover:text-amber-dark transition-colors text-sm" data-id="element-557">
            Read Our Story{' '}
            <ArrowRightIcon className="ml-2 h-4 w-4 md:h-5 md:w-5" data-id="element-558" />
          </a>
        </div>
      </div>
    </section>;
}